import React from 'react'
import {
  toInnerFuncParam,
  startOnAppGetInitialProps,
  startOnAppConstructor,
} from '../../../prefetchApi'

export default function withPrefetchApi(App) {
  return class extends React.PureComponent {
    static displayName = `fwAppWithPrefetchApi(${
      App.displayName || App.name || 'Component'
    })`

    static async getInitialProps(appCtx) {
      // 完成 next 的 getInitialProps 生命周期
      let initialProps = {}
      if ('getInitialProps' in App) {
        initialProps = await App.getInitialProps(appCtx)
      }

      // 已发生错误时跳过
      // TODO 整体基础行为，均需做错误检查，不能仅处理正向流程
      if (
        appCtx.ctx.err ||
        (initialProps.pageProps && 'statusCode' in initialProps.pageProps) ||
        appCtx.ctx.router.route === '/_error'
      ) {
        return initialProps
      }

      if (!appCtx.Component.pageConfig) {
        // 容错，Error 页，或未正确包裹 withPage 的
        appCtx.Component.pageConfig = {} // TODO 待移除
      }

      if (process.server) {
        const {
          disablePrefetchApiForRedirectPathnameList,
        } = appCtx.ctx.__AL_EX_internalScope.serverRuntimeConfig.frameworkConfig
        appCtx.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect = false
        if (disablePrefetchApiForRedirectPathnameList) {
          const { pathname } = appCtx.router
          if (disablePrefetchApiForRedirectPathnameList.includes(pathname)) {
            // 不含 basePath
            appCtx.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect = true
          }
        }
      } else {
        if (window.__NEXT_DATA__.props.isDisablePrefetchApiForRedirect) {
          throw new Error(
            '错误，不应在禁用 prefetchApi 的页面上做路由切换，应直接 redirect 到其他页面'
          )
        }
      }

      const {
        renderProps: prefetchApiInjectedProps,
        clientTaskConf,
        clientTaskMockData,
        globalPropKeys,
        pagePropsKeys,
      } = appCtx.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect
        ? {}
        : await startOnAppGetInitialProps(
            toInnerFuncParam(appCtx.ctx, appCtx.Component.pageConfig)
          )
      appCtx.ctx.__AL_EX_internalScope.extraDocProps.prefetchApiDocTask = clientTaskConf
      appCtx.ctx.__AL_EX_internalScope.extraDocProps.prefetchApiMock = clientTaskMockData

      return {
        ...initialProps,
        isDisablePrefetchApiForRedirect:
          appCtx.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect,
        pageProps: {
          ...initialProps.pageProps,
          ...prefetchApiInjectedProps,
          __AL_EX_FW_prefetchApiInitialGlobalPropKeys: globalPropKeys,
          __AL_EX_FW_prefetchApiInitialPagePropKeys: pagePropsKeys,
        },
      }
    }

    constructor(props, ...rest) {
      super(props, ...rest)

      if (process.browser) {
        // CSR 初始化，用于 CSR 首页
        props.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect =
          window.__NEXT_DATA__.props.isDisablePrefetchApiForRedirect
      }

      this.state = {
        prefetchApiInjectedProps: undefined,
      }

      // 手动将多个 prop 更新，延迟为一次更新
      // 疑惑，react 应该自行实现了这个功能，不需要手动延迟
      let lockChildRender = false

      if (!props.ctx.__AL_EX_internalScope.isDisablePrefetchApiForRedirect) {
        if (props.ctx.pathname !== '/_error') {
          const prefetchApiRenderProps = startOnAppConstructor(
            toInnerFuncParam(props.ctx, undefined, (propKey) => {
              // prop 实例已发生变化
              // 触发更新

              // 减少重复更新
              // 一次同步时序内，所有的更新将被合并
              if (!lockChildRender) {
                lockChildRender = true
                requestAnimationFrame(() => {
                  lockChildRender = false
                  this.setState({
                    prefetchApiInjectProps: { ...prefetchApiRenderProps },
                  })
                })
              }
            })
          )
          this.state.prefetchApiInjectedProps = prefetchApiRenderProps
        }
      }
    }

    render() {
      const newProps = {
        ...this.props,
        pageProps: {
          ...this.props.pageProps,
          ...this.state.prefetchApiInjectedProps,
        },
      }
      return <App {...newProps} />
    }
  }
}
